export const payloadToParams = (payload: any): { [key: string]: string } => {
  const params = {};
  Object.keys(payload).forEach(key => {
    if (payload[key] !== null && payload[key] !== undefined) {
      Object.assign(params, { [key]: String(payload[key]) });
    }
  })
  return params;
}
